import { Pipe, PipeTransform } from '@angular/core';

/** @deprecated - this is moved to libs */
@Pipe({
    name: 'familyComposition',
})
export class FamilyCompositionPipe implements PipeTransform {
    transform(input: any): string {
        if (['1MET', '2MET', '1ZON', '2ZON'].includes(input)) {
            if (input === '1MET') {
                return '1 volwassene + kind(eren)';
            }
            if (input === '2MET') {
                return '2 volwassenen + kind(eren)';
            }
            if (input === '1ZON') {
                return '1 volwassene';
            }
            if (input === '2ZON') {
                return '2 volwassenen';
            }
            return;
        }
    }
}
